import React, { useState, useEffect, useContext } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../FlyUpModal';
import { exhibitStoreId, getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './SpotifyPlayerModal.css';
import { AppContext } from "../../../../AppContext.jsx";
import { storeId } from '../../../../../../variables/Variables';
import { isMobileDevice } from '../../../../utils/DeviceDetector';
import { MusicIconClicked } from '../../../../utils/Analytics';

const arrow = "https://cdn.obsess-vr.com/umg/downward-arrow.svg";
const spotifyLogo = "https://cdn.obsess-vr.com/umg/Spotify_Icon_RGB_Green.png";
const isExhibit = storeId === exhibitStoreId;
const isMobile = isMobileDevice();

const SpotifyPlayerModal = ({welcomeScreenNumber}) => {

    const [fontStyles, setFontStyles] = useState();
    const { showSpotifyModal,setSpotifyModalVisibility, } = useContext(AppContext);

    useEffect(() => {
        fetchFontStyles();
    }, []);

    useEffect(() => {
        if(welcomeScreenNumber === 5){
            document.getElementsByClassName("spotify-music-container")[0].style.setProperty('height', '80px', 'important');
        } 
    }, [welcomeScreenNumber]);

    useEffect(() => {
        if(showSpotifyModal){
            setTimeout(() => {
                document.getElementsByClassName("spotify-music-container")[0].style.setProperty('height', '80px', 'important');
            }, 0);
            
        }else{
            setTimeout(() => {
                document.getElementsByClassName("spotify-music-container")[0].style.setProperty('height', '100%', 'important');
            }, 0);
        }
    }, [showSpotifyModal]);

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));
    }

    const handleClick = () => {
        MusicIconClicked('Music icon Clicked');
        setSpotifyModalVisibility(!showSpotifyModal);
    }

    const productButton = () => {
        return (
            <div className="product-button-container spotify-modal"><Button
                hoverStyleChange={true}
                onClick={handleClick}
                primaryColor={'#000000'}
                secondaryColor={isExhibit ? "#ffffff" : '#E9C139'}
                className={"text-marker-button flex-center obsessvr-regularFont full-width pointer product-button" + (isExhibit ? " btn-hover" : "")}
                style={{ padding: '0', margin: '0', fontFamily: 'Prelo Bold' }}
                primaryBorderColor='white'
                secondaryBorderColor='white'
                primaryBorderWidth='0px'
                secondaryBorderWidth='0px'
                insetBorder={true}
                padded={false}
            >
                <img className={showSpotifyModal ? isExhibit ? 'img190 img' : 'img190' : isExhibit ? 'img0 img' : 'img0'} src={arrow} width={24} />
            </Button></div>
        )
    }

    const spotifyMusicContainer = () => {
        return (
            <div className='spotify-music-container'>
               <iframe src="https://open.spotify.com/embed/playlist/6idDF4ma8jLebyHQpuEOob?utm_source=generator" width="100%" height="380" frameBorder="0"  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
            </div>
        )
    }

    const weclomeSpotify = () => {
        return (
                <>
               {!showSpotifyModal && <div className={`spotify-modal-content ${showSpotifyModal ? 'mobile' : ''}`} style={{ textAlign: 'center' }} >    
                    {!showSpotifyModal && productButton()}        
                    {spotifyMusicContainer()}
                    {showSpotifyModal && productButton()}
                </div>}
                <img className='spotify-btn' src={spotifyLogo} style={{display:'block', marginLeft:isMobile & isExhibit ? 'auto' : 0}} onClick={handleClick} />
                </>
            )
    }

    const renderModalContent = () => {
        const screenArr = isExhibit ? [0,2,3,4] : [2,3,4];
        return screenArr.includes(welcomeScreenNumber) ? weclomeSpotify() : (
            <>
            <div className={`spotify-modal-content ${showSpotifyModal ? 'mobile' : ''}`} style={{ textAlign: 'center' }} >    
                {!showSpotifyModal && productButton()}        
                {spotifyMusicContainer()}
                {showSpotifyModal && productButton()}
            </div>
            <img className='spotify-btn' src={spotifyLogo} onClick={handleClick} />
            </>
        )
    }
    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <div className={isExhibit && !isMobile ? "spotify-modal-container-left" : "spotify-modal-container"} style={{zIndex: `${welcomeScreenNumber === 4?'13':welcomeScreenNumber === 5?'0':'10'}`, display:`${welcomeScreenNumber === 1?"none": isMobile && (welcomeScreenNumber <=3 && welcomeScreenNumber !== 0) ? 'none' : ''}`}}>
            {!!fontStyles && renderModalContent()}
        </div>
    );
}

export default SpotifyPlayerModal;


